import React from 'react';
import { Navigate } from 'react-router-dom';

const PosFrontlineHomePage = () => {
  return <Navigate to="/checkout" replace />;
};

export default PosFrontlineHomePage;
